var portfolioPositionsWeight = {
	caption: "Portfolio positions weight",
	label: {
		name: "Libellé",
		isin: "ISIN",
		marketValue: "Valeur Boursière",
		weight: "Poids %",
		weightBar: "Poids % of max"
	},
	noPositions: "Aucun résultat trouvé"
};
var fr = {
	portfolioPositionsWeight: portfolioPositionsWeight
};

export { fr as default, portfolioPositionsWeight };
